import { ButtonBasic } from "src/components";

import { CCard, CCardBody, CContainer } from "@coreui/react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useResizeObserver } from "src/hooks";
import { TRACKS } from "../copy";

const TracksSection = () => {
  const history = useHistory();

  const { width } = useResizeObserver();
  const isMobile = width < 992;

  return (
    <section className="py-5" id="tracks">
      <div className="w-100 mx-auto  d-flex flex-column justify-content-center position-relative">
        <CContainer className="container-sm px-5">
          <div
            className={`d-flex justify-content-center aling-items-center  ${
              isMobile ? "flex-column" : "flex-row"
            } mb-3`}
            style={{
              gap: "1.5rem",
            }}
          >
            {TRACKS.map((track, index) => (
              <CCard
                style={{
                  maxWidth: "500px",
                  fontSize: "16px",
                }}
                className=" shadow"
              >
                <CCardBody className="d-flex flex-column justify-content-between pt-5 p-4">
                  <div>
                    <h2
                      className="text-info text-center mb-3"
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                      }}
                    >
                      {track.title}
                    </h2>
                    <ul className="text-left pr-5">
                      {track.points.map((point, index) => (
                        <li className="mb-3" key={index}>
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="w-100 mt-4">
                    <p
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                      }}
                      className="mb-0 w-100 text-center"
                    >
                      {track.price}
                    </p>
                    <ButtonBasic
                      onClick={() => {
                        history.push("/signup?track=" + track.name);
                      }}
                      size="lg"
                      bgcolor="green"
                      hovercolor="darkgreen"
                      className={"my-3 w-100"}
                    >
                      Start now
                    </ButtonBasic>
                  </div>
                </CCardBody>
              </CCard>
            ))}
          </div>
          <div className="w-100 d-flex justify-content-center">
            <Link
              className="text-info "
              style={{
                fontSize: "18px",
              }}
              to="/survey"
            >
              Already have an account? Login here
            </Link>
          </div>
        </CContainer>
      </div>
    </section>
  );
};

export default TracksSection;
